import { mergeStyleSets } from '@uifabric/merge-styles';
import get from 'lodash/get';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  filterListRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: pxToRem(8),
    paddingBottom: pxToRem(8),
    minHeight: pxToRem(32),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    fontWeight: 400,
    fontFamily: get(theme, 'fonts.small.fontFamily'),
    fontSize: pxToRem(14),
  },
  actionButton: {
    flexShrink: 0,
    marginLeft: pxToRem(12),
    height: pxToRem(32),
    selectors: {
      [layout.breakpoints.min.md]: {
        marginLeft: pxToRem(40),
        height: 'auto',
      },
    },
  },
  actionButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  desktopRemoveButton: {
    display: 'none',
    selectors: {
      [layout.breakpoints.min.md]: {
        display: 'inline-block',
      },
    },
  },
  mobileRemoveButton: {
    selectors: {
      [layout.breakpoints.min.md]: {
        display: 'none',
      },
    },
  },
});
